module.exports = __webpack_public_path__ + "static/carousel-2-a541576996aa356101c55410b2f3fa99.jpg";